var map = {
	"./components/DataTableExample.vue": 9691,
	"./components/ExampleComponent.vue": 9215,
	"./components/Files/FileInput.vue": 2306,
	"./components/Files/FileList.vue": 3066,
	"./components/Files/PasteInput.vue": 4981,
	"./components/Materials/ComponentAPI.vue": 5302,
	"./components/Materials/ComponentBase.vue": 3136,
	"./components/Materials/Modal.vue": 4773,
	"./components/Materials/Notifications.vue": 988,
	"./components/Materials/Select2.vue": 690,
	"./components/Materials/Spinner.vue": 8326,
	"./components/Materials/Tabs/Tab.vue": 8056,
	"./components/Materials/Tabs/Tabs.vue": 1283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6273;